export default __webpack_public_path__ + "static/media/price.86b1b047.svg";